module.exports = __webpack_public_path__ + "static/media/btn.28a0f6a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/btn.png
// module id = 989
// module chunks = 0